<template>
  <div id="EditArticleView" class="edit-article-view">
    <Header></Header>
    <b-container fluid>
      <b-row>
        <IcgLeftNav></IcgLeftNav>
        <b-col>
          <b-row>
            <ArticlesTab></ArticlesTab>
          </b-row>
          <b-row>
            <b-col class="edit-article p-0">
              <b-form id="edit-article-form" @submit.prevent="save" class="edit-form pl-3 pr-3 p-sm-4 pl-sm-5">
                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Page title">
                      <b-form-input v-model="article.pageTitle" :disabled="isLoading" required></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Page description" description="Meta tag page description">
                      <b-form-textarea v-model="article.pageDescription" :disabled="isLoading" :rows="2"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Keywords">
                      <b-form-input v-model="article.keywords" :disabled="isLoading"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="5">
                    <b-form-group label="Language">
                      <multiselect id="new-article-language-select"
                        v-model="selectedLanguage"
                        :options="languages"
                        label="name"
                        track-by="id"
                        :show-labels="false"
                        :allow-empty="false"
                        disabled>
                      </multiselect>
                    </b-form-group>
                  </b-col>
                  <b-col sm="5">
                    <b-form-group label="Category">
                      <multiselect id="new-article-category-select"
                        v-model="selectedCategory"
                        :options="categories"
                        label="name"
                        track-by="id"
                        :show-labels="false"
                        :allow-empty="false"
                        disabled>
                      </multiselect>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="URL">
                      <b-form-input v-model="article.url" disabled required></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Body title">
                      <b-form-input v-model="article.bodyTitle" :disabled="isLoading"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Lead text">
                      <b-form-textarea v-model="article.leadText" :disabled="isLoading" :rows="4" required></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="12">
                    <b-form-group label="Body description" description="Html content article">
                      <b-form-textarea v-model="article.body" :disabled="isLoading" :rows="12" required></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group label="Image URL">
                      <b-form-input v-model="article.imageUrl" :disabled="isLoading"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group>
                      <b-form-checkbox id="noIndexCheckbox"
                        v-model="noIndex"
                        value="true"
                        unchecked-value="false"
                        :disabled="isLoading">
                        Robots noindex
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row>
                  <b-col sm="10">
                    <b-form-group id="published-date" label="Published date" labelFor="published-date" class="published-date-form-label">
                      <flat-pickr id="published-date"
                        name="published-date"
                        v-model="article.publishedDate"
                        :config="config"
                        placeholder="Select date"
                        class="datetimepicker"
                        :disabled="isLoading">
                      </flat-pickr>
                    </b-form-group>
                  </b-col>
                </b-form-row>

                <b-form-row class="submit">
                  <b-col cols="12" sm="12">
                    <b-button type="submit" size="lg" variant="primary" :disabled="isLoading">Save</b-button>
                  </b-col>
                </b-form-row>
              </b-form>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import IcgLeftNav from '@/components/layout/IcgLeftNav'
import Header from '@/components/layout/Header'
import ArticlesTab from '@/components/ArticlesTab'
import flatPickr from 'vue-flatpickr-component'
export default {
  name: 'ArticlesEdit',
  components: {
    Header,
    ArticlesTab,
    IcgLeftNav,
    flatPickr
  },
  async mounted () {
    if ('id' in this.$route.params) {
      this.selectedLanguage = this.getLanguageById(this.$route.params.locale)
      await this.fetchArticleById({
        id: this.$route.params.id,
        locale: this.$route.params.locale
      })
      let newArticle = this.$store.state.icg.newArticle
      this.article = Object.assign({}, newArticle)
      this.selectedCategory = this.getCategoryById(this.article.category, this.$route.params.locale)
      this.noIndex = this.article.noIndex ? 'true' : 'false'
    } else {
      this.$router.push({name: 'articles'})
    }
  },
  computed: {
    ...mapGetters({
      'isLoading': 'loader/isLoading',
      'categoriesByLocale': 'icg/categories',
      'getLanguageById': 'icg/getLanguageById',
      'getCategoryById': 'icg/getCategoryById'
    }),
    ...mapState({
      languages: state => state.icg.languages
    }),
    categories () {
      return this.categoriesByLocale(this.$route.params.locale)
    }
  },
  methods: {
    ...mapActions({
      'saveArticle': 'icg/saveArticle',
      'startNewArticle': 'icg/startNewArticle',
      'fetchArticleById': 'icg/fetchArticleById'
    }),
    save () {
      this.saveArticle().then(() => {
        this.$toastr.s('Article saved')
        this.startNewArticle().then(() => {
          let newArticle = this.$store.state.icg.newArticle
          this.article = Object.assign({}, newArticle)
          this.$router.push({name: 'articles'})
        })
      }).catch((error) => {
        this.$toastr.e(error)
      })
    }
  },
  watch: {
    article: {
      handler (newValue) {
        this.$store.dispatch('icg/setArticle', newValue)
      },
      deep: true
    },
    noIndex: {
      handler (newValue) {
        this.article.noIndex = newValue === 'true'
      }
    }
  },
  data () {
    return {
      article: {},
      selectedCategory: {},
      selectedLanguage: {},
      noIndex: 'false',
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        enableTime: true,
        altInput: true,
        time_24hr: true
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.has-error {
  color: #ff0000;
  input {
    border-color: #ff0000;
  }
}

.edit-form {
  max-width: 750px;
}
.submit{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/icg/ArticleEdit.vue